import * as React from 'react';
import { SurfaceContextWithProperties } from '../../../types/contexts';
import { createSurfaceContextWithPropertiesProvider } from '../../common/surface-context-provider';

export interface ToastProperties {
    title?: React.ReactNode;
    children: React.ReactNode;
    autoHideDelay?: number;
    devBoxName?: string;
}

// Info Toast Context
export const InfoToastContext = React.createContext<SurfaceContextWithProperties<ToastProperties>>({
    isOpen: false,
});

export const InfoToastContextProvider = createSurfaceContextWithPropertiesProvider<ToastProperties>(InfoToastContext);

// Success Toast Context
export const SuccessToastContext = React.createContext<SurfaceContextWithProperties<ToastProperties>>({
    isOpen: false,
});

export const SuccessToastContextProvider =
    createSurfaceContextWithPropertiesProvider<ToastProperties>(SuccessToastContext);

// Error Toast Context
export const ErrorToastContext = React.createContext<SurfaceContextWithProperties<ToastProperties>>({
    isOpen: false,
});

export const ErrorToastContextProvider = createSurfaceContextWithPropertiesProvider<ToastProperties>(ErrorToastContext);

// Warning Toast Context
export const WarningToastContext = React.createContext<SurfaceContextWithProperties<ToastProperties>>({
    isOpen: false,
});

export const WarningToastContextProvider =
    createSurfaceContextWithPropertiesProvider<ToastProperties>(WarningToastContext);

// InProgress Toast Context
export const InProgressToastContext = React.createContext<SurfaceContextWithProperties<ToastProperties>>({
    isOpen: false,
});

export const InProgressToastContextProvider =
    createSurfaceContextWithPropertiesProvider<ToastProperties>(InProgressToastContext);
